











































































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Vat, Correction, ProductsApi } from '@/api';
import { VatCorrectionService } from '@/services/vat-correction-service';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {},
})
export default class MilkVatReferenceAdd extends Vue {
	public readonly smallScreen = window.innerWidth;
	private readonly toast = new Toast();

	public collectionRawDataFields: { key: string; label: string }[] = [];

	@Prop({ required: true })
	public vat!: Vat;

	@PropSync('savedReferences')
	public _savedReferences!: Correction[];

	@PropSync('parameters')
	public _parameters!: Record<string, string | number>;

	@PropSync('correction')
	public _correction!: Record<string, number | null>;

	public addReferenceForm = { notes: '', amount: '' };

	public rawData: any[] = [];
	public checkedRawData: any[] = [];

	public nDays: number = 30;
	public selectOptions: number[] = [30, 60, 90, 120, 150, 180];

	public loading: boolean = false;
	public addingReference: boolean = false;

	private readonly vatCorrectionService: VatCorrectionService = new VatCorrectionService();
	private readonly productsApi: ProductsApi = new ProductsApi();

	public get oneItemSelected(): boolean | null {
		return this.checkedRawData.length === 1
	}

	public created() {
		this.onVatChanged()
	}

	@Watch('vat', { immediate: true, deep: true })
	public async onVatChanged() {
		this.collectionRawDataFields = [
			{ key: 'sel', label: '' },
			{ key: 'start.timestamp', label: 'Collection Date' },
			{ key: 'start.volume', label: 'Volume' },
			{ key: 'start.volume', label: 'Start Volume' },
			{ key: 'finish.volume', label: 'End Volume' },
		];

		await this.setRawData();
	}

	public formatLitres(value: number): string {
		return this.$options.filters?.numeric(value) + ' L';
	}

	public rowDataRowClass(item: any): string {
		return (item?.data?.faultName?.length ?? 0) > 1
			? 'table-secondary'
			: '';
	}

	public async setRawData(): Promise<void> {
		this.checkedRawData = [];
		this.addReferenceForm.amount = '';
		await this.reloadRawData();
	}

	private async reloadRawData(): Promise<void> {
		if (this.vat.productId === undefined) {
			this.toast.makeToast(
				'Levno pickup error',
				`Failed to get Levno pickups, Product Id is incorrect or not set`,
				'danger',
			);
		}
		else {
			try {
				const response = await this.productsApi.getProductEvents(this.vat.productId, {
					params: { nDays: this.nDays },
				});
				const vatEvents = response.data.data.filter((vatEvent: any) => vatEvent.id === this.vat.id);
				const vatPickups = vatEvents[0].pickupFinish ?? [];
				this.rawData = vatPickups.filter((pickupFinishEvent: any) => pickupFinishEvent.type === "full");
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(e, `Levno Pickups`);
				this.toast.makeToast(errorMessage, `Failed to get Levno pickups`, 'danger');
			}
		}
	}

	public async clear(): Promise<void> {
		this.checkedRawData = [];
	}

	public async addReference(): Promise<void> {
		this.addingReference = true;
		const rawData = this.checkedRawData[0];
		const referenceInput = {
			vat_id: this.vat.id,
			event_timestamp: rawData.start.timestamp,
			start_volume: rawData.start.volume,
			end_volume: rawData.finish.volume,
			volume: this.addReferenceForm.amount,
			original_volume: rawData.start.volume,
			notes: this.addReferenceForm.notes,
			additional_parameters: {
				start_distance: rawData.start.distance,
				end_distance: rawData.finish.distance,
				milk_in_progress: rawData.milkingInProgress,
				pickup_type: rawData.type,
				pickup_processsed: rawData.processed,
			},
		};
		if (this.vat.id != null) {
			const response = await this.vatCorrectionService.addReference(
				this.vat.id,
				referenceInput,
			);
			if (response?.errorMessage != null)
				this.toast.makeToast(
					response.errorMessage ?? 'Unknown error, refresh and make sure the reference was added',
					'Error',
					'danger',
				);
			else {
				this.toast.makeToast('Reference point correction added', 'Success', 'success');
				this.addReferenceForm = {
					amount: '',
					notes: '',
				};
				this.checkedRawData = [];
				this.onAddedReference();
			}
		}
		this.addingReference = false;
	}

	@Emit('addedReference')
	public onAddedReference(): void { }
}
